import './Footer.css'
export default function Footer() {
  return ( 
    <div className ="container-fluid">
    <div className ='footer'>
      <p> Built and designed by Minh Trần (AnChi design).<br/> Copyright © 2022 All Rights Reserved.</p>
    </div>
    </div>
  );
}
